import { EventObject } from '@xstate/store-react';
import { AppRoute } from '../../../enums/appRoutes';
import { StoreContext } from '../../../models/store/context';
import { StoreEvent } from '../../../enums/storeEvent';
import { QuoteStatus } from '../../../models/store/quoteStatus';
import { log } from '@domgen/shared/utils/log';

/**
 * Handles quote failure by routing to the error page and setting quote status to error.
 *
 * @param context Current store context.
 * @param _event Unused event payload.
 * @param enqueue Store enqueue helpers used for navigation emission.
 * @returns Updated context with error quote status.
 */
export const quoteFailed = <T extends EventObject = EventObject>(
  context: StoreContext,
  _event: T,
  enqueue: {
    effect: (effect: () => Promise<void>) => void;
    emit: { navigate: (payload: { path: AppRoute; replace?: boolean }) => void };
  },
): StoreContext => {
  log.debug({ message: StoreEvent.QUOTE_FAILED });
  enqueue.emit.navigate({ path: AppRoute.ERROR });
  return { ...context, quote: { status: QuoteStatus.ERROR } };
};
